module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS12.5583aae5.jpg";